export const drawerToggle = (drawerOpen) => (
    {
      type: 'TOGGLE_DRAWER',
      drawerOpen
    }
);